export default{
  INFO:{},
  TOKEN:'',
  REFRESH_TOKEN:'',
  ACCESS_TOKEN:''
}


// WEBPACK FOOTER //
// ./src/store/modules/user/state.js